<div class="dining-plan-modal">
    <!-- Dining Plans section-->
    <finder-section *ngIf="diningPlan"
        [id]="'dining-plans-section'"
        [icons]="data.sectionIcons"
        [labels]="diningPlan.labels"
        [deepLink]="diningPlan.deepLink"
        [fragments] = "fragments"
        (fragmentsChange) = "updateFragments($event)"
        [expanded]="expanded">
        <finder-dining-plans [data]="diningPlan"></finder-dining-plans>
    </finder-section>

    <!-- Annual Pass section-->
    <finder-section *ngIf="annualPass" class="annual-pass"
        [id]="'annual-pass-section'"
        [icons]="data.sectionIcons"
        [labels]="annualPass.labels"
        [deepLink]="annualPass.deepLink"
        [fragments] = "fragments"
        (fragmentsChange) = "updateFragments($event)"
        [expanded]="expanded">

        <div class="content" *ngIf="!annualPass.discounts; else annualPassTable">
            <span class="description">{{annualPass.labels.description}}</span>
            <finder-breadcrumb class="breadcrumb"
                [links]="annualPass.labels.breadcrumb"
                [breadcrumb]="annualPass.labels.breadcrumbTemplate">
            </finder-breadcrumb>
        </div>
        <ng-template #annualPassTable>
            <table>
                <thead>
                    <tr>
                        <th class="type">{{annualPass.labels.type}}</th>
                        <th class="discount">{{annualPass.labels.discount}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let discount of annualPass.discounts">
                        <td class="type">{{discount.type}}</td>
                        <td class="discount">{{discount.percentage}}</td>
                    </tr>
                </tbody>
                <hr>
            </table>
            <finder-breadcrumb class="breadcrumb disclaimer"
                [links]="annualPass.labels.breadcrumb"
                [breadcrumb]="annualPass.labels.breadcrumbTemplate">
            </finder-breadcrumb>
        </ng-template>
    </finder-section>

    <!-- Disney Vacation Club -->
    <finder-section *ngIf="dvc" class="dvc"
        [id]="'dvc-section'"
        [icons]="data.sectionIcons"
        [labels]="dvc.labels"
        [deepLink]="dvc.deepLink"
        [fragments] = "fragments"
        (fragmentsChange) = "updateFragments($event)"
        [expanded]="expanded">
        <finder-breadcrumb class="breadcrumb"
            [links]="dvc.labels.breadcrumb"
            [breadcrumb]="dvc.labels.breadcrumbTemplate">
        </finder-breadcrumb>
    </finder-section>
    
    <!-- Disney Visa Cardmember -->
    <finder-section *ngIf="disneyVisa"
        class="disneyVisa"
        [id]="'dvic-section'"
        [icons]="data.sectionIcons"
        [labels]="disneyVisa.labels"
        [deepLink]="disneyVisa.deepLink"
        [fragments] = "fragments"
        (fragmentsChange) = "updateFragments($event)"
        [expanded]="expanded">
        <finder-breadcrumb class="breadcrumb"
            [links]="disneyVisa.labels.breadcrumb"
            [breadcrumb]="disneyVisa.labels.breadcrumbTemplate">
        </finder-breadcrumb>
        <span *ngIf="disneyVisa.disclaimer" class="restrictions">{{disneyVisa.disclaimer}}</span>
    </finder-section>
</div>
